module.exports = "<resources-list></resources-list>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/pages/resources/resources.component.html
// module id = ../../../../../src/app/pages/resources/resources.component.html
// module chunks = main